import axiosInstance from './axiosInstance';

const dashboardService = {
  getStats: () =>
    axiosInstance.get('/admin/dashboard/stats'),

  getAuditLogs: (params = {}) =>
    axiosInstance.get('/admin/audit-logs', { params }),
};

export default dashboardService;
